import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { PropsWithChildren } from "react";

interface Props {
    testId?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        zIndex: theme.zIndex.appBar,
        backgroundColor: "white",
        padding: "0.5rem 1rem",
        flexDirection: "row",
        alignItems: "center",
        display: "flex",
        height: "60px",
        top: 0,
        overflowX: "auto",
        overflowY: "hidden",
        "&::-webkit-scrollbar": {
            height: "3px",
        },
        "&::-webkit-scrollbar-track": {
            background: "transparent",
            height: "3px",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "rgba(0, 0, 0, 0.2)",
            height: "3px",
        },
        // Same for Firefox
        scrollbarWidth: "thin",
        scrollbarColor: "rgba(0, 0, 0, 0.2) transparent"
    }
}));

const MenuBar: React.FC<PropsWithChildren<Props>> = props => {
    const classes = useStyles();

    return (
        <div
            data-cy={props.testId}
            className={classes.root}>
            {props.children}
        </div>
    );
};

export default MenuBar;
